<template>
  <v-card class="card pa-4">
    <v-row class="ma-0">
      <v-col cols="12" class="text-center">
        <h2>Informações do padrão</h2>
      </v-col>
      <v-col cols="6">
        <strong>{{ $t('Instituição') }}</strong
        >: <span>{{ pattern.institution.name }}</span>
      </v-col>
      <v-col cols="6">
        <strong>{{ $t('Unidade') }}</strong
        >: <span>{{ pattern.unidade.name }}</span>
      </v-col>
      <v-col cols="6">
        <strong>{{ $t('Padrão') }}</strong
        >: <span>{{ pattern.name }}</span>
      </v-col>
      <v-col cols="6">
        <strong>{{ $t('Código patrimônio') }}</strong
        >: <span>{{ pattern.propertyCode }}</span>
      </v-col>
      <v-col cols="6">
        <strong>{{ $t('Modelo') }}</strong
        >: <span>{{ pattern.model }}</span>
      </v-col>
      <v-col cols="6">
        <strong>{{ $t('Num. série') }}</strong
        >: <span>{{ pattern.serialNumber }}</span>
      </v-col>
      <v-col cols="6">
        <strong>{{ $t('Fabricante') }}</strong
        >: <span>{{ pattern.manufacturer }}</span>
      </v-col>
      <v-col cols="6">
        <strong>{{ $t('Tipo') }}</strong
        >:
        <span>{{
          calibrationPatternTypes[pattern.calibrationPatternType]
        }}</span>
      </v-col>

      <v-col cols="12">
        <v-divider class="ma-4"></v-divider>
        <h3>{{ $t('Histórico de calibrações') }}</h3>
      </v-col>

      <v-col cols="12">
        <v-data-table
          :loading="loading"
          :loading-text="$t('Carregando...')"
          :no-data-text="$t('Nenhum padrão encontrado')"
          :headers="headers"
          :items="calibrations"
          class="main-table"
          hide-default-footer
          hide-default-header
          :items-per-page="filter.pageSize"
        >
          <template #header="{ props, on }">
            <thead>
              <tr>
                <th
                  class="text-center"
                  v-for="header in props.headers"
                  :key="header.value"
                >
                  <v-simple-checkbox
                    v-if="header.value === 'data-table-select'"
                    v-model="props.everyItem"
                    :indeterminate="props.someItems && !props.everyItem"
                    color="purple"
                    @input="on['toggle-select-all']"
                  ></v-simple-checkbox>

                  <div>
                    <v-hover v-slot="{ hover }">
                      <div>
                        <span>{{ $t(header.text) }}</span>
                        <v-icon
                          v-if="
                            hover &&
                            header.value != 'data-table-select' &&
                            header.value != 'actions'
                          "
                          color="white"
                          class="mx-2"
                          @click="on.sort(header.value)"
                        >
                          {{
                            props.options.sortBy.includes(header.value)
                              ? `mdi-chevron-down`
                              : `mdi-chevron-up`
                          }}
                        </v-icon>
                      </div>
                    </v-hover>
                  </div>
                </th>
              </tr>
            </thead>
          </template>
          <template #[`item.equipment.unidade.name`]="{ item }">
            <div class="d-flex justify-center">
              <span
                style="
                  text-align: center;
                  max-width: 180px !important;
                  display: block;
                  width: 180px !important;
                "
              >
                {{
                  item.equipment &&
                  item.equipment.unidade &&
                  item.equipment.unidade.name
                    ? item.equipment.unidade.name
                    : 'Sem registro'
                }}
              </span>
            </div>
          </template>
          <template #[`item.calibrationDate`]="{ item }">
            {{
              item.calibrationDate
                ? formatDate(item.calibrationDate)
                : 'Sem registro'
            }}
          </template>
        </v-data-table>

        <div class="pagination">
          <div class="item-pagination block-one">
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="btn"
                  depressed
                  color="#C0C0C0"
                  small
                >
                  qtd: {{ pageSize }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(size, i) in sizes"
                  :key="i"
                  @click="pageSize = size"
                >
                  <v-list-item-title>{{ size }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <div class="registros" v-if="pageSize">
              <span> 1 - {{ pageSize }} de {{ pager.totalItems }} </span>
            </div>
          </div>

          <div class="item-pagination block-two">
            <v-pagination
              class="pagination-item"
              v-model="page"
              :length="pager.totalPages"
              :total-visible="3"
            ></v-pagination>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'

export default {
  name: 'CalibrationPatternDetail',

  props: {
    pattern: Object,
  },

  created() {
    if (this.pattern && this.pattern.id) this.getCalibrations()
  },

  data() {
    return {
      calibrationPatternTypes: ['Simulador', 'Analisador'],
      sizes: [10, 30, 90, 180],
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
          width: 20,
        },
        {
          text: 'Equipamento',
          align: 'center',
          value: 'equipment.identification',
          width: 100,
        },
        {
          text: 'Unidade',
          align: 'center',
          value: 'equipment.unidade.name',
          width: 50,
        },
        {
          text: 'Usuário executor',
          align: 'center',
          value: 'executingUser.name',
          width: 50,
        },
        {
          text: 'Data da calibração',
          align: 'center',
          value: 'calibrationDate',
          width: 50,
        },
      ],
      pager: {},
      page: 1,
      totalPages: 1,
      pageSize: 10,
      filter: {
        page: 1,
        pageSize: 10,
      },
      calibrations: [],
      apiService: new ApiService(),
    }
  },

  methods: {
    formatDate(date) {
      return Utils.moment(date)
    },
    getCalibrations() {
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.apiService
        .get(
          `calibrationPattern/calibrations?page=${this.filter.page}&pageSize=${this.filter.pageSize}&patternId=${this.pattern.id}`
        )
        .then((response) => {
          this.calibrations = response.content.calibrations
          this.pager = response.content.pager
          this.totalItensOnPage = response.content.calibrations.length
        })
    },
  },

  watch: {
    pageSize() {
      this.filter.page = 1
      this.getCalibrations()
    },

    page() {
      this.getCalibrations()
    },
  },
}
</script>

<style></style>
